module.exports = __webpack_public_path__ + "static/media/CATT04.00716bfa.jpg";